import React from 'react';
import { useGetOne } from 'react-admin';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import type { PartnerSettings } from '@src/settings';
import PricingUnavailableGuard from './PricingUnavailableGuard';

/**
 * Wrapper that checks partner settings and shows PricingUnavailableGuard
 * when useAbsoluteValuesForPricing is enabled. Shows a loading spinner
 * while settings are being fetched.
 */
const WithPricingGuard = ({ children }: { children: React.ReactNode }) => {
  const { data: settings, isLoading } = useGetOne<PartnerSettings & { id: number }>('settings', { id: 0 });

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (settings?.useAbsoluteValuesForPricing) {
    return <PricingUnavailableGuard />;
  }

  return <>{children}</>;
};

export default WithPricingGuard;
